import React, { Component, useEffect, useLayoutEffect, useRef, useState } from "react";

import "../financeiro.css";
import "../financeiro-table/table.css";
import "./notas-fiscais.css";

import AppContext from "../../appContext";
import NotasFiscaisModal, { ETAPA_CONFIRMACAO, ETAPA_PROGRESSO, ETAPA_SUCESSO, ORIGEM_PERIODO, ORIGEM_SELECIONADAS } from "./notas-fiscais-modal";
import AppButton from "../../shared/components/generic/button/app-button";
import EmptyState from "../../shared/components/generic/empty-state/empty-state";
import Pagination from "../../shared/components/generic/pagination/pagination";
import CnpjUtils from "../../shared/utils/CnpjUtils";
import DateUtils from "../../shared/utils/DateUtils";
import MonetaryUtils from "../../shared/utils/MonetaryUtils";
import { Relacionamento } from "../../Functions/gestao-laboratorios/relacionamento";
import { getNotasFiscais, postDownloadNotasFiscais, getDanfe } from "../../Functions/gestao-financeira-cliente-laboratorio/notas-fiscais";

import ReactDOM from "react-dom";
import { Redirect } from "react-router-dom";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import MaskedInput from "react-text-mask";
import ptBR from "date-fns/locale/pt-BR";
import "react-datepicker/dist/react-datepicker.css";
import { Checkbox, CircularProgress, TextField } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { Search } from "react-bootstrap-icons";
import { BsBoxArrowInDown, BsFileEarmarkCode, BsFileEarmarkText, BsSearch } from "react-icons/bs";

const MODULO_FINANCEIRO = "Financeiro";
const MASCARA_DE_DATA = [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];
const NOTAS_POR_PAGINA = 10;
const NOTAS_POR_COLETA = 50;
const INTERVALO_PROGRESSO = 400;
const LIMITE_PROGRESSO = 95;

const MENSAGEM_SESSAO_EXPIRADA = "Sua sessão expirou. Por favor, faça login novamente para continuar.";
const MENSAGEM_COMUNICACAO =
  "Tivemos um problema de comunicação com o servidor. Verifique sua conexão e tente novamente em alguns instantes. Caso necessário, entre em contato com o seu laboratório.";
const MENSAGEM_PERIODO_INVALIDO = "A data inicial deve ser anterior ou igual à data final.";
const MENSAGEM_SEM_RESULTADO = "Nenhuma nota fiscal encontrada para o período selecionado.";
const MENSAGEM_SEM_RELACIONAMENTO = "A ótica informada não possui relacionamento com o laboratório.";
const MENSAGEM_SEM_PERMISSAO = "Operação não permitida: você não possui permissão para baixar estas notas fiscais.";
const MENSAGEM_PERIODO_INCOMPLETO = "Não foi possível reunir todas as notas fiscais do período. Tente novamente em alguns instantes.";

const MENSAGENS_BUSCA = {
  403: "Operação não permitida: você não possui permissão para consultar estas notas fiscais.",
};
const MENSAGENS_DOWNLOAD = {
  403: MENSAGEM_SEM_PERMISSAO,
  404: "Não foi possível realizar o download. Nenhuma nota fiscal correspondente foi localizada.",
  422: "Dados inválidos. Não foi possível processar o download das notas selecionadas.",
};
const MENSAGENS_DOCUMENTO = {
  403: MENSAGEM_SEM_PERMISSAO,
  404: "Nota fiscal não encontrada.",
};

const DOCUMENTOS = {
  PDF: { tipo: "application/pdf", extensao: "pdf", icone: BsFileEarmarkText },
  XML: { tipo: "application/xml", extensao: "xml", icone: BsFileEarmarkCode },
};

function base64ParaBytes(base64) {
  const binario = atob(base64);
  const bytes = new Uint8Array(binario.length);
  for (let i = 0; i < binario.length; i++) {
    bytes[i] = binario.charCodeAt(i);
  }
  return bytes;
}

function conteudoDoDocumento(documento, tipoDocumento) {
  if (tipoDocumento === "XML" && documento.trim().startsWith("<")) {
    return documento;
  }
  return base64ParaBytes(documento);
}

function salvarArquivo(conteudo, tipo, nome) {
  const url = window.URL.createObjectURL(new Blob([conteudo], { type: tipo }));
  const link = document.createElement("a");
  link.href = url;
  link.download = nome;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

function chaveDaNota(nota) {
  return `${nota.numero}-${nota.serie}-${nota.codigoEmpresa}`;
}

const EntradaDeData = ({ inputRef, ...props }) => (
  <MaskedInput {...props} ref={ref => inputRef(ref ? ref.inputElement : null)} mask={MASCARA_DE_DATA} guide={false} />
);

const CalendarioSobreposto = ({ children }) => ReactDOM.createPortal(children, document.body);

const CampoDeData = ({ id, rotulo, valor, erro, ajuda, onChange }) => (
  <DatePicker
    id={id}
    selected={valor}
    onChange={onChange}
    dateFormat="dd/MM/yyyy"
    placeholderText="dd/mm/aaaa"
    locale={ptBR}
    strictParsing
    useWeekdaysShort
    calendarClassName="nf-calendario"
    popperContainer={CalendarioSobreposto}
    autoComplete="off"
    customInput={
      <TextField
        variant="outlined"
        size="small"
        className="lp-field"
        label={rotulo}
        InputLabelProps={{ shrink: true }}
        InputProps={{ inputComponent: EntradaDeData }}
        error={Boolean(erro)}
        helperText={ajuda}
      />
    }
  />
);

const ContadorDeSelecao = ({ quantidade }) => {
  const ultimaQuantidade = useRef(quantidade);

  useEffect(() => {
    if (quantidade > 0) {
      ultimaQuantidade.current = quantidade;
    }
  }, [quantidade]);

  const exibida = quantidade || ultimaQuantidade.current;

  return (
    <span className="nf-contador">
      <span aria-hidden="true">{exibida || ""}</span>
      <span className="visually-hidden">{exibida === 1 ? "(1 nota)" : `(${exibida} notas)`}</span>
    </span>
  );
};

const RotulosDeDownload = ({ quantidade }) => {
  const periodo = useRef(null);
  const selecionadas = useRef(null);
  const [largura, setLargura] = useState(0);
  const temSelecao = quantidade > 0;

  useLayoutEffect(() => {
    const ativo = temSelecao ? selecionadas.current : periodo.current;
    const medir = () => setLargura(Math.ceil(ativo.getBoundingClientRect().width));

    medir();

    if (!window.ResizeObserver) {
      return undefined;
    }

    const observador = new ResizeObserver(medir);
    observador.observe(ativo);

    return () => observador.disconnect();
  }, [temSelecao, quantidade]);

  return (
    <span className="nf-botao__rotulo">
      <BsBoxArrowInDown size={16} aria-hidden="true" />
      <span className="nf-botao__texto">
        {"Baixar "}
        <span className="nf-botao__complementos" style={largura ? { "--nf-largura-do-rotulo": `${largura}px` } : undefined}>
          <span ref={periodo} className={`nf-botao__complemento${temSelecao ? " nf-botao__complemento--oculto" : ""}`} aria-hidden={temSelecao}>
            todas do período
          </span>
          <span ref={selecionadas} className={`nf-botao__complemento${temSelecao ? "" : " nf-botao__complemento--oculto"}`} aria-hidden={!temSelecao}>
            selecionadas da página
            <ContadorDeSelecao quantidade={quantidade} />
          </span>
        </span>
      </span>
    </span>
  );
};

class NotasFiscais extends Component {
  static contextType = AppContext;

  state = {
    dia_inicio: null,
    dia_fim: null,
    erroPeriodo: "",
    buscando: false,
    consulta: null,
    notas: null,
    total: 0,
    pagina: 1,
    selecionadas: [],
    documentoEmDownload: "",
    progresso: 0,
    aviso: null,
    etapaModal: null,
    origemModal: ORIGEM_PERIODO,
    versaoPaginacao: 0,
    redirectL: false,
  };

  montado = false;
  temporizador = null;

  componentDidMount() {
    this.montado = true;
  }

  componentWillUnmount() {
    this.montado = false;
    clearInterval(this.temporizador);
  }

  atualizar = estado => {
    if (this.montado) {
      this.setState(estado);
    }
  };

  exibirAviso = (severidade, mensagem) => {
    this.atualizar({ aviso: { severidade, mensagem } });
  };

  estaOcupado() {
    const { buscando, etapaModal } = this.state;

    return buscando || etapaModal === ETAPA_PROGRESSO;
  }

  restaurarPaginacao() {
    this.atualizar(({ versaoPaginacao }) => ({ versaoPaginacao: versaoPaginacao + 1 }));
  }

  handleChangeData = campo => data => {
    this.setState({ [campo]: data, erroPeriodo: "" });
  };

  validar() {
    const { redeOticas } = this.context.userSession;
    const { laboratorio_dados, redeOticaAux, input_cnpj, cnpj_number } = this.props;

    if (!laboratorio_dados?.laboratorio_cnpj) {
      this.props.handleChangeProps("labError", null, "Selecione um laboratório");
      return false;
    }

    if (redeOticaAux && !cnpj_number && (redeOticas || input_cnpj)) {
      this.exibirAviso("warning", redeOticas ? "Selecione uma ótica." : "O campo CNPJ é obrigatório.");
      return false;
    }

    if (DateUtils.formatDateToAmerican(this.state.dia_inicio) > DateUtils.formatDateToAmerican(this.state.dia_fim)) {
      this.setState({ erroPeriodo: MENSAGEM_PERIODO_INVALIDO });
      return false;
    }

    return true;
  }

  tratarErro({ status, erro }, mensagens, mensagemDaApi = false) {
    if (status >= 200 && status < 400) {
      return false;
    }

    if (status === 401) {
      Swal.fire({
        text: MENSAGEM_SESSAO_EXPIRADA,
        title: "Aviso",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: false,
        confirmButtonColor: "#00518b",
        confirmButtonText: "Ok",
      }).then(() => this.atualizar({ redirectL: true }));
      return true;
    }

    const erroDaApi = mensagemDaApi && status >= 400 && status < 500 ? erro : "";

    this.exibirAviso("warning", erroDaApi || mensagens[status] || MENSAGEM_COMUNICACAO);
    return true;
  }

  buscar = async () => {
    if (!this.validar()) {
      return;
    }

    const consulta = {
      laboratorio: this.props.laboratorio_dados.laboratorio_cnpj,
      laboratorioNome: this.props.laboratorio_dados.laboratorio_nome,
      otica: this.props.cnpj_number,
      dataInicio: DateUtils.formatDateToAmerican(this.state.dia_inicio),
      dataFim: DateUtils.formatDateToAmerican(this.state.dia_fim),
    };

    this.setState({ buscando: true, aviso: null, notas: null, total: 0, selecionadas: [] });

    if (this.context.userSession.papelCategoria === "LABORATORIO") {
      const relacionamento = await Relacionamento(consulta.laboratorio, CnpjUtils.cleanCnpj(consulta.otica)).catch(() => null);

      if (relacionamento !== true) {
        this.atualizar({ buscando: false });
        this.exibirAviso("warning", relacionamento === false ? MENSAGEM_SEM_RELACIONAMENTO : MENSAGEM_COMUNICACAO);
        return;
      }
    }

    this.carregarPagina(consulta, 1);
  };

  carregarPagina = async (consulta, pagina) => {
    this.atualizar({ buscando: true, aviso: null });

    const resultado = await getNotasFiscais({ ...consulta, pagina, tamanho: NOTAS_POR_PAGINA });

    this.atualizar({ buscando: false });

    if (this.tratarErro(resultado, MENSAGENS_BUSCA, true)) {
      this.restaurarPaginacao();
      return;
    }

    this.atualizar({
      consulta,
      notas: resultado.notas.map(nota => ({ ...nota, chave: chaveDaNota(nota) })),
      total: resultado.total,
      pagina,
      selecionadas: [],
    });
  };

  trocarPagina = ({ selected }) => {
    if (this.estaOcupado()) {
      this.restaurarPaginacao();
      return;
    }

    this.carregarPagina(this.state.consulta, selected + 1);
  };

  alternarNota = chave => {
    this.setState(({ selecionadas }) => ({
      selecionadas: selecionadas.includes(chave) ? selecionadas.filter(item => item !== chave) : [...selecionadas, chave],
    }));
  };

  alternarTodas = () => {
    this.setState(({ selecionadas, notas }) => ({
      selecionadas: selecionadas.length === notas.length ? [] : notas.map(nota => nota.chave),
    }));
  };

  iniciarProgresso() {
    clearInterval(this.temporizador);
    this.setState({ progresso: 0 });
    this.temporizador = setInterval(() => {
      this.atualizar(({ progresso }) => ({ progresso: progresso + (LIMITE_PROGRESSO - progresso) * 0.08 }));
    }, INTERVALO_PROGRESSO);
  }

  coletarNotasDoPeriodo = async () => {
    const { consulta, notas, total } = this.state;

    if (total <= notas.length) {
      return notas;
    }

    const paginas = Math.ceil(total / NOTAS_POR_COLETA);
    const coletadas = [];

    for (let pagina = 1; pagina <= paginas; pagina++) {
      const resultado = await getNotasFiscais({ ...consulta, pagina, tamanho: NOTAS_POR_COLETA });

      if (this.tratarErro(resultado, MENSAGENS_BUSCA, true)) {
        return null;
      }

      coletadas.push(...resultado.notas);
    }

    if (coletadas.length < total) {
      this.exibirAviso("warning", MENSAGEM_PERIODO_INCOMPLETO);
      return null;
    }

    return coletadas;
  };

  baixarZip = async obterNotas => {
    const { consulta } = this.state;
    this.iniciarProgresso();

    try {
      const notas = await obterNotas();

      if (!notas) {
        return false;
      }

      const resultado = await postDownloadNotasFiscais({ ...consulta, notas });

      if (this.tratarErro(resultado, MENSAGENS_DOWNLOAD)) {
        return false;
      }

      salvarArquivo(base64ParaBytes(resultado.conteudo), "application/zip", `notas_fiscais_${consulta.dataInicio}_a_${consulta.dataFim}.zip`);
      return true;
    } catch (error) {
      this.exibirAviso("warning", MENSAGEM_COMUNICACAO);
      return false;
    } finally {
      clearInterval(this.temporizador);
    }
  };

  baixarSelecionadas = async () => {
    const { notas, selecionadas } = this.state;

    this.setState({ etapaModal: ETAPA_PROGRESSO, origemModal: ORIGEM_SELECIONADAS, aviso: null });

    const concluido = await this.baixarZip(() => notas.filter(nota => selecionadas.includes(nota.chave)));

    this.atualizar({ etapaModal: concluido ? ETAPA_SUCESSO : null });
  };

  abrirConfirmacao = () => {
    this.setState({ etapaModal: ETAPA_CONFIRMACAO, origemModal: ORIGEM_PERIODO });
  };

  confirmarBaixarTodas = async () => {
    this.setState({ etapaModal: ETAPA_PROGRESSO, aviso: null });

    const concluido = await this.baixarZip(this.coletarNotasDoPeriodo);

    this.atualizar({ etapaModal: concluido ? ETAPA_SUCESSO : null });
  };

  baixarDocumento = async (nota, tipoDocumento) => {
    if (this.state.documentoEmDownload) {
      return;
    }

    const { tipo, extensao } = DOCUMENTOS[tipoDocumento];
    const mensagemPadrao = `Não foi possível baixar a nota fiscal ${nota.numero} em ${tipoDocumento}. Tente novamente em alguns instantes.`;

    this.setState({ documentoEmDownload: `${nota.chave}-${tipoDocumento}` });

    const resultado = await getDanfe({ ...this.state.consulta, numero: nota.numero, tipoDocumento });

    this.atualizar({ documentoEmDownload: "" });

    if (resultado.status === 401) {
      this.tratarErro(resultado, MENSAGENS_DOCUMENTO);
      return;
    }

    if (resultado.status !== 200) {
      this.context.showSnack(MENSAGENS_DOCUMENTO[resultado.status] || mensagemPadrao, "warning");
      return;
    }

    try {
      salvarArquivo(conteudoDoDocumento(resultado.documento, tipoDocumento), tipo, `Nota_Fiscal_N°_${nota.numero}.${extensao}`);
    } catch (error) {
      this.context.showSnack(mensagemPadrao, "warning");
    }
  };

  renderDocumento(nota, tipoDocumento) {
    const Icone = DOCUMENTOS[tipoDocumento].icone;
    const baixando = this.state.documentoEmDownload === `${nota.chave}-${tipoDocumento}`;

    return (
      <button
        type="button"
        className={`nf-pilula nf-pilula--${DOCUMENTOS[tipoDocumento].extensao}`}
        aria-disabled={Boolean(this.state.documentoEmDownload)}
        aria-label={`Baixar nota fiscal ${nota.numero} em ${tipoDocumento}`}
        onClick={() => this.baixarDocumento(nota, tipoDocumento)}>
        {baixando ? <CircularProgress size={12} color="inherit" /> : <Icone size={12} aria-hidden="true" />}
        {tipoDocumento}
      </button>
    );
  }

  renderResultado() {
    const { notas, total, pagina, selecionadas, versaoPaginacao } = this.state;

    if (notas.length === 0) {
      return <EmptyState icon={Search} title="Nenhum registro encontrado" description={MENSAGEM_SEM_RESULTADO} />;
    }

    const ocupado = this.estaOcupado();
    const temSelecao = selecionadas.length > 0;
    const paginas = Math.ceil(total / NOTAS_POR_PAGINA);

    return (
      <>
        <div className="nf-cartao nf-acoes">
          <p className="nf-acoes__titulo">Baixar notas fiscais em XML</p>
          <div className="nf-acoes__botoes">
            <AppButton
              id="btn-baixar-notas-fiscais"
              className="nf-botao nf-botao--contorno"
              disabled={ocupado}
              onClick={temSelecao ? this.baixarSelecionadas : this.abrirConfirmacao}>
              <RotulosDeDownload quantidade={selecionadas.length} />
            </AppButton>
          </div>
        </div>

        <div className="nf-cartao nf-tabela">
          <table>
            <thead>
              <tr>
                <th className="nf-tabela__selecao">
                  <Checkbox
                    className="nf-checkbox"
                    size="small"
                    color="primary"
                    checked={selecionadas.length === notas.length}
                    disabled={ocupado}
                    onChange={this.alternarTodas}
                    inputProps={{ "aria-label": "Selecionar todas as notas da página" }}
                  />
                </th>
                <th>Nº Nota / Série</th>
                <th>Data Emissão</th>
                <th>Download</th>
                <th>Valor</th>
              </tr>
            </thead>
            <tbody>
              {notas.map(nota => (
                <tr key={nota.chave}>
                  <td className="nf-tabela__selecao">
                    <Checkbox
                      className="nf-checkbox"
                      size="small"
                      color="primary"
                      checked={selecionadas.includes(nota.chave)}
                      disabled={ocupado}
                      onChange={() => this.alternarNota(nota.chave)}
                      inputProps={{ "aria-label": `Selecionar nota fiscal ${nota.numero}` }}
                    />
                  </td>
                  <td>
                    <strong>{nota.numero}</strong>
                    {nota.serie && <span className="nf-tabela__serie">Série {nota.serie}</span>}
                  </td>
                  <td>{DateUtils.formatDateToBrazilian(nota.dataEmissao)}</td>
                  <td>
                    <div className="nf-tabela__downloads">
                      {this.renderDocumento(nota, "PDF")}
                      {this.renderDocumento(nota, "XML")}
                    </div>
                  </td>
                  <td className="nf-tabela__valor">{MonetaryUtils.formatCurrency(nota.valor)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="nf-total">{total === 1 ? "1 nota encontrada" : `${total} notas encontradas`}</p>

        {paginas > 1 && <Pagination key={versaoPaginacao} pageCount={paginas} currentPage={pagina - 1} onPageChange={this.trocarPagina} />}
      </>
    );
  }

  render() {
    const { dia_inicio, dia_fim, erroPeriodo, buscando, notas, total, aviso, etapaModal, origemModal, consulta } = this.state;
    const progresso = Math.round(this.state.progresso);

    if (this.state.redirectL || sessionStorage.getItem("token") === null) {
      return <Redirect to="/" />;
    }

    if (!(this.context.userSession.modulos || []).includes(MODULO_FINANCEIRO)) {
      return <Redirect to="/home" />;
    }

    return (
      <>
        <div className="nf-cartao nf-periodo">
          <p className="nf-periodo__titulo">Selecione o período de emissão</p>
          <div className="nf-periodo__campos">
            <CampoDeData
              id="data_inicio_notas_fiscais"
              rotulo="Data inicial"
              valor={dia_inicio}
              erro={erroPeriodo}
              ajuda={erroPeriodo}
              onChange={this.handleChangeData("dia_inicio")}
            />
            <CampoDeData id="data_fim_notas_fiscais" rotulo="Data final" valor={dia_fim} erro={erroPeriodo} onChange={this.handleChangeData("dia_fim")} />
            <AppButton
              id="btn-buscar-notas-fiscais"
              className="nf-botao nf-periodo__buscar"
              disabled={!dia_inicio || !dia_fim || this.estaOcupado()}
              startIcon={buscando ? <CircularProgress size={16} color="inherit" /> : <BsSearch size={16} aria-hidden="true" />}
              onClick={this.buscar}>
              {buscando ? "Buscando..." : "Buscar"}
            </AppButton>
          </div>
        </div>

        {aviso && (
          <Alert className="nf-aviso" severity={aviso.severidade} closeText="Fechar" onClose={() => this.setState({ aviso: null })}>
            {aviso.mensagem}
          </Alert>
        )}

        {notas && this.renderResultado()}

        <NotasFiscaisModal
          etapa={etapaModal}
          origem={origemModal}
          progresso={progresso}
          periodo={consulta ? `${DateUtils.formatDateToBrazilian(consulta.dataInicio)} a ${DateUtils.formatDateToBrazilian(consulta.dataFim)}` : ""}
          quantidade={total}
          laboratorio={consulta ? consulta.laboratorioNome : ""}
          onConfirmar={this.confirmarBaixarTodas}
          onFechar={() => this.setState({ etapaModal: null })}
        />
      </>
    );
  }
}

export default NotasFiscais;
